import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Core from '../../../lib/Core';
import {
  Fun
} from '../../../lib/Function.lib';
import useState from '../../../lib/hooks/useState.hook';
import {
  Obj
} from '../../../lib/Object.lib';
import Loader from '../../Shared/Loader';
import Typography from './Typography';

const KEY__CON__SIMPLE_BACKDROP = 'controllerSimpleBackdrop';

export function getControllerSimpleBackdrop() {
  return {
    state: {},
    updateState: Fun,
    open: Fun,
    close: Fun,
    ...Obj(Core.getKeyValue(KEY__CON__SIMPLE_BACKDROP))
  };
}

export function setControllerSimpleBackdrop(controller) {
  return Core.setKeyValue(KEY__CON__SIMPLE_BACKDROP, controller);
}

export default function SimpleBackdrop({
  closeOnClick = false,
  ...props
}) {
  const [state, updateState] = useState();

  const open = () => {
    updateState({ open: true });
  };

  const close = () => {
    updateState({ open: false });
  };

  setControllerSimpleBackdrop({
    state,
    updateState,
    open,
    close,
  });

  const wrapperProps = {
    sx: { color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, ...props.sx },
    open: state.open,
    onClick: closeOnClick ? close : (event) => {
      Core.showWarning(
        <>
          <Typography className='f-md fw-600 mr-1'>
            Please wait for the operation to complete
          </Typography>
          <Loader />
        </>
      );
    },
    ...props
  };

  return (
    <Backdrop {...wrapperProps}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
